/**
 * The icon set, keyed by the Lucide kebab-case name the design files use
 * (`<Icon name="arrow-left" />`). Only icons listed here ship in the bundle, so
 * add a line when a screen needs a new glyph. Names come from the design project
 * (every page's JSX) plus the common UI glyphs screens will need.
 */
import * as L from 'lucide-react';

import type { LucideIcon } from 'lucide-react';

export const ICONS = {
  'table-2': L.Table2,
  'alarm-clock': L.AlarmClock,
  activity: L.Activity,
  'arrow-down': L.ArrowDown,
  'arrow-left': L.ArrowLeft,
  'arrow-right': L.ArrowRight,
  'arrow-up': L.ArrowUp,
  'arrow-up-right': L.ArrowUpRight,
  'at-sign': L.AtSign,
  'badge-check': L.BadgeCheck,
  ban: L.Ban,
  'battery-low': L.BatteryLow,
  bell: L.Bell,
  'bell-off': L.BellOff,
  binoculars: L.Binoculars,
  blend: L.Blend,
  'book-open': L.BookOpen,
  bookmark: L.Bookmark,
  'bookmark-plus': L.BookmarkPlus,
  brain: L.Brain,
  'building-2': L.Building2,
  calendar: L.Calendar,
  'calendar-days': L.CalendarDays,
  'chart-column': L.ChartColumn,
  'chart-line': L.ChartLine,
  'chart-no-axes-combined': L.ChartNoAxesCombined,
  'chart-pie': L.ChartPie,
  check: L.Check,
  'check-check': L.CheckCheck,
  'check-square': L.CheckSquare,
  'chevron-down': L.ChevronDown,
  'chevron-left': L.ChevronLeft,
  'chevron-right': L.ChevronRight,
  'chevron-up': L.ChevronUp,
  'chevrons-up-down': L.ChevronsUpDown,
  circle: L.Circle,
  'circle-alert': L.CircleAlert,
  'circle-check': L.CircleCheck,
  'circle-dollar-sign': L.CircleDollarSign,
  'circle-help': L.CircleHelp,
  'circle-stop': L.CircleStop,
  'circle-x': L.CircleX,
  clock: L.Clock,
  'cloud-upload': L.CloudUpload,
  coins: L.Coins,
  'columns-3': L.Columns3,
  command: L.Command,
  copy: L.Copy,
  'corner-down-right': L.CornerDownRight,
  cpu: L.Cpu,
  'credit-card': L.CreditCard,
  dot: L.Dot,
  download: L.Download,
  ellipsis: L.Ellipsis,
  'external-link': L.ExternalLink,
  eye: L.Eye,
  'eye-off': L.EyeOff,
  flame: L.Flame,
  'calendar-clock': L.CalendarClock,
  receipt: L.Receipt,
  headset: L.Headset,
  'file-down': L.FileDown,
  'file-pen-line': L.FilePenLine,
  'file-text': L.FileText,
  filter: L.Filter,
  flag: L.Flag,
  'flask-conical': L.FlaskConical,
  funnel: L.Funnel,
  gauge: L.Gauge,
  gift: L.Gift,
  'git-fork': L.GitFork,
  globe: L.Globe,
  'grid-2x2': L.Grid2x2,
  'grip-vertical': L.GripVertical,
  history: L.History,
  home: L.Home,
  hourglass: L.Hourglass,
  image: L.Image,
  'image-plus': L.ImagePlus,
  images: L.Images,
  'indian-rupee': L.IndianRupee,
  info: L.Info,
  key: L.Key,
  layers: L.Layers,
  'layout-dashboard': L.LayoutDashboard,
  'layout-grid': L.LayoutGrid,
  library: L.Library,
  lightbulb: L.Lightbulb,
  'link-2': L.Link2,
  'list-checks': L.ListChecks,
  loader: L.Loader,
  'loader-circle': L.LoaderCircle,
  lock: L.Lock,
  'log-in': L.LogIn,
  'log-out': L.LogOut,
  mail: L.Mail,
  'mail-check': L.MailCheck,
  'map-pin': L.MapPin,
  'maximize-2': L.Maximize2,
  megaphone: L.Megaphone,
  'message-circle': L.MessageCircle,
  'message-circle-off': L.MessageCircleOff,
  'message-circle-plus': L.MessageCirclePlus,
  'message-square': L.MessageSquare,
  mic: L.Mic,
  'messages-square': L.MessagesSquare,
  'minimize-2': L.Minimize2,
  minus: L.Minus,
  monitor: L.Monitor,
  moon: L.Moon,
  'mouse-pointer-click': L.MousePointerClick,
  'octagon-alert': L.OctagonAlert,
  package: L.Package,
  palette: L.Palette,
  'panel-left-close': L.PanelLeftClose,
  'panel-left-open': L.PanelLeftOpen,
  paperclip: L.Paperclip,
  pause: L.Pause,
  'pen-line': L.PenLine,
  map: L.Map,
  'party-popper': L.PartyPopper,
  pencil: L.Pencil,
  percent: L.Percent,
  phone: L.Phone,
  pin: L.Pin,
  play: L.Play,
  plug: L.Plug,
  plus: L.Plus,
  printer: L.Printer,
  radar: L.Radar,
  radio: L.Radio,
  'receipt-text': L.ReceiptText,
  'refresh-cw': L.RefreshCw,
  repeat: L.Repeat,
  'rotate-ccw': L.RotateCcw,
  'scan-search': L.ScanSearch,
  route: L.Route,
  search: L.Search,
  'search-x': L.SearchX,
  send: L.Send,
  settings: L.Settings,
  shirt: L.Shirt,
  sigma: L.Sigma,
  'image-off': L.ImageOff,
  shapes: L.Shapes,
  'share-2': L.Share2,
  'shield-alert': L.ShieldAlert,
  'shopping-bag': L.ShoppingBag,
  'sliders-horizontal': L.SlidersHorizontal,
  smartphone: L.Smartphone,
  sparkle: L.Sparkle,
  sparkles: L.Sparkles,
  split: L.Split,
  square: L.Square,
  'square-pen': L.SquarePen,
  star: L.Star,
  stethoscope: L.Stethoscope,
  store: L.Store,
  sun: L.Sun,
  table: L.Table,
  tag: L.Tag,
  target: L.Target,
  'thumbs-down': L.ThumbsDown,
  'thumbs-up': L.ThumbsUp,
  'trash-2': L.Trash2,
  'trending-down': L.TrendingDown,
  'trending-up': L.TrendingUp,
  'triangle-alert': L.TriangleAlert,
  truck: L.Truck,
  upload: L.Upload,
  user: L.User,
  users: L.Users,
  wallet: L.Wallet,
  'wand-sparkles': L.WandSparkles,
  x: L.X,
  'zoom-in': L.ZoomIn,
  'zoom-out': L.ZoomOut,
  zap: L.Zap,
  /* Phase 3 product components */
  archive: L.Archive,
  'arrow-down-right': L.ArrowDownRight,
  'arrow-up-down': L.ArrowUpDown,
  'badge-indian-rupee': L.BadgeIndianRupee,
  'chart-scatter': L.ChartScatter,
  clapperboard: L.Clapperboard,
  'copy-plus': L.CopyPlus,
  database: L.Database,
  'gallery-horizontal-end': L.GalleryHorizontalEnd,
  'git-merge': L.GitMerge,
  inbox: L.Inbox,
  'panel-right-open': L.PanelRightOpen,
  'shield-check': L.ShieldCheck,
  telescope: L.Telescope,
  video: L.Video,
  'volume-2': L.Volume2,
  /* Names the design files use from older Lucide releases, mapped to the current glyphs */
  'check-circle': L.CircleCheck,
  'alert-circle': L.CircleAlert,
  'alert-triangle': L.TriangleAlert,
  'more-horizontal': L.Ellipsis,
  'more-vertical': L.Ellipsis,
  'line-chart': L.ChartLine,
  'scatter-chart': L.ChartScatter,
  'help-circle': L.CircleHelp,
  /* Creative and competitor analysis */
  'arrow-down-wide-narrow': L.ArrowDownWideNarrow,
  wrench: L.Wrench,
  timer: L.Timer,
  quote: L.Quote,
  rocket: L.Rocket,
  'circle-pause': L.CirclePause,
  trophy: L.Trophy,
  shuffle: L.Shuffle,
  magnet: L.Magnet,
  'message-square-quote': L.MessageSquareQuote,
  'layout-template': L.LayoutTemplate,
  'user-round': L.UserRound,
  'badge-percent': L.BadgePercent,
  'audio-lines': L.AudioLines,
  'map-pinned': L.MapPinned,
  'contact-round': L.ContactRound,
} satisfies Record<string, LucideIcon>;

export type IconName = keyof typeof ICONS;
